import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link, useLocation } from "react-router-dom";

const navItems = {
    "/": { name: "Home" },
    "/education": { name: "Education" },
    "/projects": { name: "Projects" },
    "/certificates": { name: "Certificates" },
    "/contact": { name: "Contact" },
};

export default function Navbar() {
    const location = useLocation();
    let pathname = location.pathname;

    if (pathname.includes("/writing/")) {
        pathname = "/writing";
    }

    const [hoveredPath, setHoveredPath] = useState(pathname);

    return (
        <div className="max-[400px]:p-1.5 border border-stone-800/90 p-2 sm:p-2 md:p-2 rounded-lg mb-8 sticky top-4 z-[100] bg-stone-900/80 backdrop-blur-md">
            <nav className="flex gap-1 sm:gap-2 md:gap-3 relative justify-start w-full z-[100] rounded-lg flex-wrap">
                {Object.entries(navItems).map(([path, { name }]) => {
                    const isActive = path === pathname;

                    return (
                        <Link
                            key={path}
                            className={`max-[400px]:px-1 px-2 py-1 sm:px-3 sm:py-2 rounded-md text-xs sm:text-sm md:text-base relative no-underline transition duration-300 ${isActive ? "text-white" : "text-zinc-400"}`}
                            to={path}
                            onMouseOver={() => setHoveredPath(path)}
                            onMouseLeave={() => setHoveredPath(pathname)}
                        >
                            <span>{name}</span>
                            {path === hoveredPath && (
                                <motion.div
                                    className="absolute bottom-0 left-0 h-full bg-stone-800/80 rounded-md -z-10 border border-stone-700/30"
                                    layoutId="navbar"
                                    aria-hidden="true"
                                    style={{ width: "100%" }}
                                    transition={{
                                        type: "spring",
                                        bounce: 0.25,
                                        stiffness: 130,
                                        damping: 9,
                                        duration: 0.3,
                                    }}
                                />
                            )}
                        </Link>
                    );
                })}
            </nav>
        </div>
    );
}
